export default function () {
  return {
    restrict: "A",
    link: function (scope, elem) {
      elem.on("click", function () {

        console.log('document:', angular.element(document).find('.input-wrapper.error'))
        
        // var firstError = elem.find('input.error')[0];
        
        // if (firstError) {
        //   firstError.focus();
        // }

        // try{
        //   if( firstError.parent().find('select').length > 0){
            
        //   }
        // }catch(e){

        // }

      });
    }
  };
}